"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{OverlayTrigger as r}from"./src/OverlayTrigger.js";e("overlay-trigger",r);
//# sourceMappingURL=overlay-trigger.js.map
